import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SortEnum } from 'src/app/utils/enums/sort-enum';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { environment } from 'src/environments/environment';
import { FiltresService } from '../filtres/filtres.service';

import { map } from 'rxjs/operators';

const logsTBBEndpoint = `${environment.basePath}/logs/logs/tbb`;
const logsTBBExportEndpoint = `${environment.basePath}/logs/logs/tbb/export`;

@Injectable({
  providedIn: 'root'
})
export class LogTableauDeBordService {

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders(),
    params: undefined
  };

  constructor(
    private _httpClient: HttpClient,
    private _filtresService: FiltresService,
  ) { }

  public async getLogs(params: LogTbbFilter, pageFiltres: Filtres = {
    perpage: 30,
    currentPage: 1,
    sortOrder: SortEnum.DESC,
    sortBy: 'timestamp'
  }): Promise<Paginated<LogTableauDeBordGet>> {
    return new Promise<Paginated<LogTableauDeBordGet>>(async (resolve) => {
      try {
        const options = {...this.httpOptions};
        options.headers = this._filtresService.setHeaders(pageFiltres)

        let httpParams = new HttpParams();

        if (params.type) {
          httpParams = httpParams.append('LogTableauDeBordFilterTypeTarget', params.type);
        }

        if (params.finess) {
          httpParams = httpParams.append('LogTableauDeBordFilterFinessDestinataire', params.finess);
        }

        if (params.rpps) {
          httpParams = httpParams.append('LogTableauDeBordFilterRPPSDestinataire', params.rpps);
        }

        if (params.finessExpediteur) {
          httpParams = httpParams.append('LogTableauDeBordFilterFinessExpediteur', params.finessExpediteur);
        }

        if (params.rppsExpediteur) {
          httpParams = httpParams.append('LogTableauDeBordFilterRPPSExpediteur', params.rppsExpediteur);
        }

        if (params.dateDebut) {
          httpParams = httpParams.append('LogTableauDeBordFilterDateDebut', params.dateDebut);
        }

        if (params.dateFin) {
          httpParams = httpParams.append('LogTableauDeBordFilterDateFin', params.dateFin);
        }

        if (params.typeDocument) {
          httpParams = httpParams.append('LogTableauDeBordFilterTypeDocument', params.typeDocument);
        }

        if (params.isSuccessful !== undefined) {
          httpParams = httpParams.append('LogTableauDeBordFilterIsSuccessful', params.isSuccessful.toString());
        }

        options.params = httpParams;

        const res = await this._httpClient.get<Array<LogTableauDeBordGet>>(
          logsTBBEndpoint,
          options
        ).toPromise();

        const paginated: Paginated<LogTableauDeBordGet> = {
          page: Number(res.headers.get('x-page')),
          perpage: Number(res.headers.get('x-per-page')),
          total: Number(res.headers.get('x-total')),
          objects: res.body
        };
        resolve(paginated);
      } catch (e) {
        console.error(e);
      }
    });
  }

  public async addLogTableauDeBord(log: LogTBBObject): Promise<void> {
    return new Promise<void>(async (resolve) => {
      try {
        const logRqt: LogTableauDeBordPost = {
          typeLogs: log.typeLogs,
          patientID: log.patientID,
          isSuccessful: log.isSuccessful,
          typeDocument: log.typeDocument,
        };
        await this._addLogTableauDeBord(logRqt);
        resolve();
      } catch (e) {
        console.error(e);
      }
    });
  }

  private async _addLogTableauDeBord(log: LogTableauDeBordPost): Promise<void> {
    try {
      await this._httpClient.post(
        logsTBBEndpoint,
        log
      ).toPromise();
    } catch (e) {
      console.error(e);
    }
  }

  public async exportLogs() {
    const options = {...this.httpOptions};
    options.params = undefined;
    options.headers = undefined;
    (options as any).responseType = 'text' as any;
    const res = await this._httpClient.get<any>(
      logsTBBExportEndpoint,
      options
    ).toPromise();
    return res.body;
  }
}

export interface LogTBBObject {
  typeLogs?: EnumLogTableauDeBordFrontType;
  patientID: string;
  isSuccessful: boolean;
  typeDocument?: string;
}

export interface LogTableauDeBordPost {
  typeLogs: EnumLogTableauDeBordFrontType;
  patientID: string;
  isSuccessful: boolean;
  typeDocument?: string;
}

export enum EnumLogTableauDeBordFrontType {
  DMP = "DMP",
  DMP_LECTURE = "DMP_LECTURE",
  MSS = "MSS",
}

export interface LogTbbFilter {
  type?: string;
  finess?: string;
  rpps?: string;
  finessExpediteur?: string;
  rppsExpediteur?: string;
  dateDebut?: string;
  dateFin?: string;
  isSuccessful?: boolean;
  typeDocument?: string;
}

export interface LogTableauDeBordGet {
  uuid: string;
  typeLogs: string;
  finess?: string;
  rpps?: string;
  timestamp: Date;
}

export enum EnumLogTableauDeBordTypeFront {
  DMP_INS_QUALIFIE = "DMP INS QUALIFIE",
  DMP_INS_NON_QUALIFIE = "DMP INS NON QUALIFIE",
  MSS_PATIENT_INS_QUALIFIE = "MSS PATIENT INS QUALIFIE",
  MSS_PATIENT_INS_NON_QUALIFIE = "MSS PATIENT INS NON QUALIFIE",
  MSS_PRO_INS_QUALIFIE = "MSS PRO INS QUALIFIE",
  MSS_PRO_INS_NON_QUALIFIE = "MSS PRO INS NON QUALIFIE",
}

export enum EnumLogTableauDeBordType {
  DMP_INS_QUALIFIE = "DMP_INS_QUALIFIE",
  DMP_INS_NON_QUALIFIE = "DMP_INS_NON_QUALIFIE",
  MSS_PATIENT_INS_QUALIFIE = "MSS_PATIENT_INS_QUALIFIE",
  MSS_PATIENT_INS_NON_QUALIFIE = "MSS_PATIENT_INS_NON_QUALIFIE",
  MSS_PRO_INS_QUALIFIE = "MSS_PRO_INS_QUALIFIE",
  MSS_PRO_INS_NON_QUALIFIE = "MSS_PRO_INS_NON_QUALIFIE",
  DMP_LECTURE = "DMP_LECTURE",
}
